module.exports = __webpack_public_path__ + "img/selected7-min.1bb82326.png";